export const allowedPlansIntervalsKeys = ['MONTH', 'YEAR', 'OTHER'];

export const MAX_PLAN_DESCRIPTION_LENGTH = 120;

export const MAX_PLAN_FEATURE_DESCRIPTION_LENGTH = 100;
